import { Box, Button, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector, RootState } from "../../store";
import { useNavigate } from "react-router-dom";
import { getFormGroup, rmvMsgSccsFGr } from "../../store/feature/formGroup";

// icon
import AddIcon from "@mui/icons-material/Add";
import Toast from "../../components/atoms/toast";
import AdminRoleSearch from "../../components/molecules/adminRole/AdminRoleSearch";
import AdminRoleTable from "../../components/molecules/adminRole/AdminRoleTable";
import { getAdminRolesList } from "../../store/feature/adminRoles";
import ListDataSkeleton from "../../components/template/skeleton/ListDataSkeleton";

const AdminRole = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [params, setParams] = useState<object>({});
  const [defaultValue, setDefaultValue] = useState({});

  const { admRole } = useAppSelector((state: RootState) => state.user);
  const { isLoadingAdmRoles, isLoadingEvent } = useAppSelector(
    (state: RootState) => state.admRoles
  );
  const { dataFGroup, msgSccsFGr } = useAppSelector(
    (state: RootState) => state.fGroup
  );

  const handleCloseToast = () => {
    dispatch(rmvMsgSccsFGr());
  };

  useEffect(() => {
    dispatch(getAdminRolesList(params));
  }, [params]);

  return (
    <ListDataSkeleton
      isLoading={isLoadingAdmRoles}
      isLoadingEvent={isLoadingEvent}
      titleWidth={"300"}
    >
      <Box>
        <Typography
          variant="h3"
          fontFamily="Open Sans"
          sx={{ marginY: "20px" }}
        >
          Admin Roles
        </Typography>

        {admRole.uc_adm_pge_acs_create === 1 && (
          <Box sx={{ display: "flex", flexDirection: "row-reverse" }}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => navigate("/admin-roles/create")}
              sx={{ marginBottom: "18px" }}
            >
              <AddIcon /> Create
            </Button>
          </Box>
        )}
        <AdminRoleSearch params={params} setParams={setParams} />
        <AdminRoleTable
          data={dataFGroup}
          params={params}
          setParams={setParams}
          defaultValue={defaultValue}
          setDefaultValue={setDefaultValue}
        />
        <Toast
          severity="success"
          open={msgSccsFGr !== ""}
          handleClose={handleCloseToast}
          message={msgSccsFGr}
        />
      </Box>
    </ListDataSkeleton>
  );
};

export default AdminRole;
